/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ManagementRole } from './ManagementRole';
import {
    ManagementRoleFromJSON,
    ManagementRoleFromJSONTyped,
    ManagementRoleToJSON,
    ManagementRoleToJSONTyped,
} from './ManagementRole';
import type { FleetRole } from './FleetRole';
import {
    FleetRoleFromJSON,
    FleetRoleFromJSONTyped,
    FleetRoleToJSON,
    FleetRoleToJSONTyped,
} from './FleetRole';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * 
 * @export
 * @interface UserCreate
 */
export interface UserCreate {
    /**
     * Personal Number. Needs to be unique. Between 1 and 100 characters.
     * @type {string}
     * @memberof UserCreate
     */
    employeeId: string;
    /**
     * Password. Between 10 and 100 characters.
     * @type {string}
     * @memberof UserCreate
     */
    password?: string | null;
    /**
     * First name. Between 1 and 100 characters.
     * @type {string}
     * @memberof UserCreate
     */
    firstName: string;
    /**
     * Last name. Between 1 and 100 characters.
     * @type {string}
     * @memberof UserCreate
     */
    lastName: string;
    /**
     * Email address. Needs to be unique. Between 5 and 32 characters.
     * @type {string}
     * @memberof UserCreate
     */
    email?: string | null;
    /**
     * Management role. One of: `Auditor`, `ManagementAdmin`, `SuperAdmin`
     * @type {ManagementRole}
     * @memberof UserCreate
     */
    managementRole?: ManagementRole | null;
    /**
     * Fleet role. One of: `Driver`, `MaintenanceManager`, `Supervisor`
     * @type {FleetRole}
     * @memberof UserCreate
     */
    fleetRole?: FleetRole | null;
    /**
     * Free form field for describing the user's job.
     * @type {string}
     * @memberof UserCreate
     */
    jobTitle?: string | null;
    /**
     * Department Id. A unique identifier from departments table
     * @type {string}
     * @memberof UserCreate
     */
    departmentId?: string | null;
    /**
     * Shift Id. A unique identifier from shifts table
     * @type {string}
     * @memberof UserCreate
     */
    shiftId?: string | null;
    /**
     * Site Id. A unique identifier from sites table
     * @type {string}
     * @memberof UserCreate
     */
    siteId?: string | null;
    /**
     * License Expiry Date.
     * @type {Date}
     * @memberof UserCreate
     */
    licenseExpiryDate?: Date | null;
    /**
     * Expiry Logout.
     * @type {boolean}
     * @memberof UserCreate
     */
    expiryLogout: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    nfcToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    nfcTokenDescription?: string | null;
    /**
     * 
     * @type {LengthUnit}
     * @memberof UserCreate
     */
    lengthUnit?: LengthUnit | null;
}



/**
 * Check if a given object implements the UserCreate interface.
 */
export function instanceOfUserCreate(value: object): value is UserCreate {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('expiryLogout' in value) || value['expiryLogout'] === undefined) return false;
    return true;
}

export function UserCreateFromJSON(json: any): UserCreate {
    return UserCreateFromJSONTyped(json, false);
}

export function UserCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'password': json['password'] == null ? undefined : json['password'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'managementRole': json['managementRole'] == null ? undefined : ManagementRoleFromJSON(json['managementRole']),
        'fleetRole': json['fleetRole'] == null ? undefined : FleetRoleFromJSON(json['fleetRole']),
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'licenseExpiryDate': json['licenseExpiryDate'] == null ? undefined : (new Date(json['licenseExpiryDate'])),
        'expiryLogout': json['expiryLogout'],
        'nfcToken': json['nfcToken'] == null ? undefined : json['nfcToken'],
        'nfcTokenDescription': json['nfcTokenDescription'] == null ? undefined : json['nfcTokenDescription'],
        'lengthUnit': json['lengthUnit'] == null ? undefined : LengthUnitFromJSON(json['lengthUnit']),
    };
}

export function UserCreateToJSON(json: any): UserCreate {
    return UserCreateToJSONTyped(json, false);
}

export function UserCreateToJSONTyped(value?: UserCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'managementRole': ManagementRoleToJSON(value['managementRole']),
        'fleetRole': FleetRoleToJSON(value['fleetRole']),
        'jobTitle': value['jobTitle'],
        'departmentId': value['departmentId'],
        'shiftId': value['shiftId'],
        'siteId': value['siteId'],
        'licenseExpiryDate': value['licenseExpiryDate'] == null ? value['licenseExpiryDate'] : value['licenseExpiryDate'].toISOString(),
        'expiryLogout': value['expiryLogout'],
        'nfcToken': value['nfcToken'],
        'nfcTokenDescription': value['nfcTokenDescription'],
        'lengthUnit': LengthUnitToJSON(value['lengthUnit']),
    };
}

